export default "__VITE_ASSET__1db56dea__"